import { render } from "./CreateSpeciality.vue?vue&type=template&id=6d463cb1&scoped=true"
import script from "./CreateSpeciality.vue?vue&type=script&lang=js"
export * from "./CreateSpeciality.vue?vue&type=script&lang=js"

import "./CreateSpeciality.vue?vue&type=style&index=0&id=6d463cb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d463cb1"]])

export default __exports__